module.exports = __webpack_public_path__ + "img/account_statement.c94d0d0c.svg";